// Preserve tag values supplied as array elements (including embedded commas).
export function normalizeTags(value) {
  const tags = Array.isArray(value) ? value : typeof value === "string" ? value.split(",") : [];
  return tags.filter(tag => typeof tag === "string").map(tag => tag.trim()).filter(Boolean);
}
